import { render } from "./ios_app_download.vue?vue&type=template&id=7a8504a9"
import script from "./ios_app_download.vue?vue&type=script&lang=js"
export * from "./ios_app_download.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__